/* Vegas Crystal Healings: immersive crystal viewer (hover magnify + full-screen viewer with zoom, pan and pinch).
   Works on top of the theme's own product gallery. Photos are shown exactly as uploaded; the large file loads only when asked for. */
(function () {
  'use strict';
  if (window.__vchViewer) return;
  window.__vchViewer = true;

  var MAXZ = 4, HOVERZ = 2.2;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var canHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 750px)').matches;

  function hiRes(img, w) {
    var u = img.getAttribute('data_max_resolution') || img.currentSrc || img.src;
    if (!u) return '';
    if (/[?&]width=\d+/.test(u)) return u.replace(/([?&]width=)\d+/, '$1' + w);
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function el(tag, cls, attrs) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (attrs) for (var k in attrs) e.setAttribute(k, attrs[k]);
    return e;
  }
  function containerSelector() { return '.product-media-container--image'; }
  function galleryItems(fromEl) {
    var gallery = fromEl.closest('media-gallery');
    if (!gallery) return [];
    var grid = fromEl.closest('.media-gallery__grid');
    var scope = grid || fromEl.closest('slideshow-component') || gallery;
    var items = Array.prototype.slice.call(scope.querySelectorAll(containerSelector()));
    return items.filter(function (li) { return !li.closest('zoom-dialog') && li.querySelector('img.product-media__image'); });
  }

  /* ---------- Hover magnify (desktop) ---------- */
  var lensCache = {};
  function setupLens(li) {
    if (li.__vchLens) return li.__vchLens;
    var img = li.querySelector('img.product-media__image');
    var host = img.closest('.product-media') || li;
    var lens = el('div', 'vch-lens', { 'aria-hidden': 'true' });
    host.appendChild(lens);
    var url = hiRes(img, 2400);
    var state = { lens: lens, img: img, host: host, url: url, ready: false };
    var pre = new Image();
    pre.onload = function () { state.ready = true; lens.style.backgroundImage = 'url("' + url.replace(/"/g, '%22') + '")'; if (state.pending) moveLens(li, state.pending); };
    pre.src = url;
    lensCache[url] = true;
    li.__vchLens = state;
    return state;
  }
  function moveLens(li, ev) {
    var s = li.__vchLens;
    if (!s) return;
    if (!s.ready) { s.pending = { clientX: ev.clientX, clientY: ev.clientY }; return; }
    var r = s.img.getBoundingClientRect();
    var nw = s.img.naturalWidth || 1, nh = s.img.naturalHeight || 1;
    var ratio = nw / nh, boxRatio = r.width / r.height;
    var fit = (window.getComputedStyle(s.img).objectFit || 'contain');
    var w, h;
    if (fit === 'cover') { if (ratio > boxRatio) { h = r.height; w = h * ratio; } else { w = r.width; h = w / ratio; } }
    else { if (ratio > boxRatio) { w = r.width; h = w / ratio; } else { h = r.height; w = h * ratio; } }
    var ox = (r.width - w) / 2, oy = (r.height - h) / 2;
    var mx = ev.clientX - r.left, my = ev.clientY - r.top;
    var px = Math.max(0, Math.min(w, mx - ox)), py = Math.max(0, Math.min(h, my - oy));
    var hr = s.host.getBoundingClientRect();
    var hx = ev.clientX - hr.left, hy = ev.clientY - hr.top;
    s.lens.style.backgroundSize = (w * HOVERZ) + 'px ' + (h * HOVERZ) + 'px';
    s.lens.style.backgroundPosition = (hx - px * HOVERZ) + 'px ' + (hy - py * HOVERZ) + 'px';
    s.lens.classList.add('is-on');
  }
  if (canHover) {
    document.addEventListener('pointermove', function (ev) {
      if (ev.pointerType !== 'mouse') return;
      var li = ev.target.closest && ev.target.closest('media-gallery .media-gallery__grid ' + containerSelector());
      if (!li || li.closest('zoom-dialog')) return;
      if (!li.querySelector('img.product-media__image')) return;
      setupLens(li);
      moveLens(li, ev);
    }, { passive: true });
    document.addEventListener('pointerout', function (ev) {
      var li = ev.target.closest && ev.target.closest(containerSelector());
      if (!li || !li.__vchLens) return;
      if (ev.relatedTarget && li.contains(ev.relatedTarget)) return;
      li.__vchLens.lens.classList.remove('is-on');
      li.__vchLens.pending = null;
    });
  }

  /* ---------- Full-screen viewer ---------- */
  var V = null;
  function build() {
    var d = el('dialog', 'vch-viewer', { 'aria-label': 'Photo viewer' });
    d.innerHTML =
      '<div class="vch-viewer__top">' +
        '<div class="vch-viewer__title"><span class="vch-viewer__name"></span><span class="vch-viewer__count"></span></div>' +
        '<button type="button" class="vch-viewer__close" aria-label="Close photo viewer">Close <span aria-hidden="true">&times;</span></button>' +
      '</div>' +
      '<div class="vch-viewer__stage">' +
        '<button type="button" class="vch-viewer__nav vch-viewer__prev" aria-label="Previous photo">&#8249;</button>' +
        '<img class="vch-viewer__img" alt="" draggable="false">' +
        '<div class="vch-viewer__loading" aria-hidden="true">Loading full detail&hellip;</div>' +
        '<button type="button" class="vch-viewer__nav vch-viewer__next" aria-label="Next photo">&#8250;</button>' +
      '</div>' +
      '<div class="vch-viewer__bottom">' +
        '<div class="vch-viewer__zoom" role="group" aria-label="Zoom">' +
          '<button type="button" class="vch-viewer__zbtn" data-z="out" aria-label="Zoom out">&minus;</button>' +
          '<span class="vch-viewer__pct" aria-live="polite">100%</span>' +
          '<button type="button" class="vch-viewer__zbtn" data-z="in" aria-label="Zoom in">+</button>' +
          '<button type="button" class="vch-viewer__reset">Reset</button>' +
        '</div>' +
        '<div class="vch-viewer__thumbs"></div>' +
        '<p class="vch-viewer__hint"></p>' +
      '</div>';
    document.body.appendChild(d);
    var v = {
      d: d, stage: d.querySelector('.vch-viewer__stage'), img: d.querySelector('.vch-viewer__img'),
      name: d.querySelector('.vch-viewer__name'), count: d.querySelector('.vch-viewer__count'),
      pct: d.querySelector('.vch-viewer__pct'), thumbs: d.querySelector('.vch-viewer__thumbs'),
      loading: d.querySelector('.vch-viewer__loading'), prev: d.querySelector('.vch-viewer__prev'), next: d.querySelector('.vch-viewer__next'),
      hint: d.querySelector('.vch-viewer__hint'),
      items: [], i: 0, z: 1, x: 0, y: 0, pts: {}, g: null, lastTap: 0, trigger: null
    };
    v.hint.textContent = canHover
      ? 'Drag to explore · scroll or double-click to zoom · ← → to change photo · Esc to close'
      : 'Pinch to zoom · drag to explore · double-tap to zoom · swipe for more photos';
    d.querySelector('.vch-viewer__close').addEventListener('click', close);
    v.prev.addEventListener('click', function () { go(-1); });
    v.next.addEventListener('click', function () { go(1); });
    d.querySelector('[data-z="in"]').addEventListener('click', function () { zoomTo(v.z + 0.5); });
    d.querySelector('[data-z="out"]').addEventListener('click', function () { zoomTo(v.z - 0.5); });
    d.querySelector('.vch-viewer__reset').addEventListener('click', function () { zoomTo(1); });
    d.addEventListener('cancel', function (e) { e.preventDefault(); close(); });
    document.addEventListener('keydown', function (e) {
      if (!d.open) return;
      if (e.target && e.target.tagName === 'INPUT') return;
      if (e.key === 'Escape') { e.preventDefault(); close(); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); }
      else if (e.key === '+' || e.key === '=') { e.preventDefault(); zoomTo(v.z + 0.5); }
      else if (e.key === '-' || e.key === '_') { e.preventDefault(); zoomTo(v.z - 0.5); }
      else if (e.key === '0') { e.preventDefault(); zoomTo(1); }
    });
    v.stage.addEventListener('wheel', function (e) { e.preventDefault(); zoomTo(v.z + (e.deltaY < 0 ? 0.25 : -0.25)); }, { passive: false });
    v.stage.addEventListener('dblclick', function (e) { if (e.target.closest('button')) return; zoomTo(v.z > 1 ? 1 : 2.5); });
    v.stage.addEventListener('pointerdown', down);
    v.stage.addEventListener('pointermove', move);
    v.stage.addEventListener('pointerup', up);
    v.stage.addEventListener('pointercancel', up);
    return v;
  }
  function dist() { var a = Object.keys(V.pts).map(function (k) { return V.pts[k]; }); return Math.hypot(a[0].x - a[1].x, a[0].y - a[1].y); }
  function down(e) {
    if (e.target.closest('button')) return;
    try { V.stage.setPointerCapture(e.pointerId); } catch (err) {}
    V.pts[e.pointerId] = { x: e.clientX, y: e.clientY };
    var n = Object.keys(V.pts).length;
    if (n === 2) V.g = { mode: 'pinch', d: dist(), z: V.z };
    else if (n === 1) V.g = { mode: 'pan', sx: e.clientX, sy: e.clientY, x: V.x, y: V.y, moved: false };
    V.img.classList.add('is-dragging');
  }
  function move(e) {
    if (!V.pts[e.pointerId] || !V.g) return;
    V.pts[e.pointerId] = { x: e.clientX, y: e.clientY };
    if (V.g.mode === 'pinch' && Object.keys(V.pts).length === 2) { zoomTo(V.g.z * dist() / V.g.d, true); return; }
    if (V.g.mode === 'pan') {
      var dx = e.clientX - V.g.sx, dy = e.clientY - V.g.sy;
      if (Math.abs(dx) + Math.abs(dy) > 6) V.g.moved = true;
      if (V.z > 1) { V.x = V.g.x + dx; V.y = V.g.y + dy; clamp(); apply(); }
    }
  }
  function up(e) {
    var g = V.g;
    delete V.pts[e.pointerId];
    var n = Object.keys(V.pts).length;
    if (n === 1) { var p = V.pts[Object.keys(V.pts)[0]]; V.g = { mode: 'pan', sx: p.x, sy: p.y, x: V.x, y: V.y, moved: true }; return; }
    V.g = null;
    V.img.classList.remove('is-dragging');
    if (!g || g.mode !== 'pan') return;
    var dx = e.clientX - g.sx;
    if (V.z === 1 && g.moved && Math.abs(dx) > 50 && V.items.length > 1) { go(dx < 0 ? 1 : -1); return; }
    if (!g.moved && e.pointerType !== 'mouse') {
      var now = Date.now();
      if (now - V.lastTap < 300) { zoomTo(V.z > 1 ? 1 : 2.5); V.lastTap = 0; } else V.lastTap = now;
    }
  }
  function clamp() {
    var w = V.img.offsetWidth * V.z, h = V.img.offsetHeight * V.z;
    var sw = V.stage.clientWidth, sh = V.stage.clientHeight;
    var mx = Math.max(0, (w - sw) / 2), my = Math.max(0, (h - sh) / 2);
    V.x = Math.max(-mx, Math.min(mx, V.x));
    V.y = Math.max(-my, Math.min(my, V.y));
  }
  function apply() {
    V.img.style.transform = 'translate(' + V.x + 'px,' + V.y + 'px) scale(' + V.z + ')';
    V.pct.textContent = Math.round(V.z * 100) + '%';
    V.stage.classList.toggle('is-zoomed', V.z > 1);
  }
  function zoomTo(z, live) {
    z = Math.max(1, Math.min(MAXZ, Math.round(z * 100) / 100));
    V.z = z;
    if (z === 1) { V.x = 0; V.y = 0; } else clamp();
    if (live) V.img.classList.add('is-dragging'); else V.img.classList.remove('is-dragging');
    apply();
  }
  function show(i) {
    var n = V.items.length;
    V.i = (i + n) % n;
    var src = V.items[V.i];
    V.z = 1; V.x = 0; V.y = 0; apply();
    V.img.alt = src.alt || '';
    V.img.src = src.low;
    V.loading.classList.add('is-on');
    var hi = new Image();
    var want = V.i;
    hi.onload = function () { if (V.i !== want) return; V.img.src = src.high; V.loading.classList.remove('is-on'); };
    hi.onerror = function () { V.loading.classList.remove('is-on'); };
    hi.src = src.high;
    V.count.textContent = n > 1 ? 'Photo ' + (V.i + 1) + ' of ' + n : '';
    V.prev.hidden = V.next.hidden = n < 2;
    Array.prototype.forEach.call(V.thumbs.children, function (b, k) { b.setAttribute('aria-current', k === V.i ? 'true' : 'false'); });
    var t = V.thumbs.children[V.i];
    if (t && t.scrollIntoView) t.scrollIntoView({ block: 'nearest', inline: 'center', behavior: reduce ? 'auto' : 'smooth' });
  }
  function go(d) { if (V.items.length > 1) show(V.i + d); }
  function open(items, index, trigger) {
    if (!V) V = build();
    V.items = items;
    V.trigger = trigger;
    var h1 = document.querySelector('main h1, h1');
    V.name.textContent = h1 ? h1.textContent.trim() : '';
    V.thumbs.innerHTML = '';
    V.thumbs.hidden = items.length < 2;
    items.forEach(function (it, k) {
      var b = el('button', 'vch-viewer__thumb', { type: 'button', 'aria-label': 'Show photo ' + (k + 1) });
      var im = el('img', '', { alt: '', loading: 'lazy' });
      im.src = it.thumb;
      b.appendChild(im);
      b.addEventListener('click', function () { show(k); });
      V.thumbs.appendChild(b);
    });
    document.documentElement.classList.add('vch-viewer-open');
    if (V.d.showModal) V.d.showModal(); else V.d.setAttribute('open', '');
    show(index);
    V.d.querySelector('.vch-viewer__close').focus();
  }
  function close() {
    if (!V) return;
    V.pts = {}; V.g = null;
    if (V.d.open && V.d.close) V.d.close(); else V.d.removeAttribute('open');
    document.documentElement.classList.remove('vch-viewer-open');
    if (V.trigger && V.trigger.focus) { try { V.trigger.focus({ preventScroll: true }); } catch (e) {} }
  }

  window.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var li = t.closest(containerSelector());
    if (!li || !li.closest('media-gallery') || li.closest('zoom-dialog') || li.closest('dialog')) return;
    if (!li.querySelector('img.product-media__image')) return;
    if (t.closest('a, input, select, textarea') || t.closest('.slideshow-control, slideshow-arrows')) return;
    var items = galleryItems(li);
    var idx = items.indexOf(li);
    if (idx < 0) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var list = items.map(function (x) {
      var img = x.querySelector('img.product-media__image');
      return { low: img.currentSrc || img.src, high: hiRes(img, 2400), thumb: hiRes(img, 200), alt: img.alt };
    });
    open(list, idx, t.closest('button') || li);
  }, true);
})();
